module.exports = __webpack_public_path__ + "static/media/loan-management-logo.2cb28e70.png";